<template>
  <section class="contact">
    <div class="container">
      <h2 class="titulo">{{ $t('homePage.promoverMarca') }}</h2>
      <p class="descricao inter-regular">&nbsp;</p>
      <p class="descricao inter-regular">{{ $t('homePage.orcamento') }}</p>
      <button type="button" class="email-button" @click="copyEmail">{{ contactEmail }}</button>
      <p v-if="emailCopied" class="copied-text">Email copiado!</p>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

// Altere o e-mail de contato aqui.
const contactEmail = 'CONTATO@GUSMACHADO.COM.BR'
const emailCopied = ref(false)

const copyEmail = async () => {
  try {
    if (navigator?.clipboard?.writeText) {
      await navigator.clipboard.writeText(contactEmail)
    } else {
      const tempInput = document.createElement('textarea')
      tempInput.value = contactEmail
      tempInput.setAttribute('readonly', '')
      tempInput.style.position = 'absolute'
      tempInput.style.left = '-9999px'
      document.body.appendChild(tempInput)
      tempInput.select()
      document.execCommand('copy')
      document.body.removeChild(tempInput)
    }
    emailCopied.value = true
    setTimeout(() => {
      emailCopied.value = false
    }, 1800)
  } catch (_error) {
    emailCopied.value = false
  }
}
</script>

<style scoped>
.contact {
  min-height: 0;
  background: var(--color-bg-dark);
  color: var(--color-light);
  overflow-x: hidden;
}

.container {
  max-width: 1100px;
  width: 100%;
  margin: 0 auto;
  padding: 40px 24px;
  text-align: left;
}

.titulo {
  margin: 0;
  font-family: "Bebas Neue", sans-serif;
  font-size: 50px;
  font-weight: 400;
  line-height: 1.1;
}

.descricao {
  margin: 0;
  font-size: 20px;
  line-height: 1.5;
}

.email-button {
  margin-top: 8px;
  padding: 10px 0;
  border: none;
  background: transparent;
  color: var(--color-yellow);
  font-family: "Archivo", sans-serif;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  max-width: 100%;
  text-align: left;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.email-button:hover {
  color: var(--color-light);
}

.copied-text {
  margin: 6px 0 0;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: var(--color-light);
  opacity: 0.9;
}

@media (aspect-ratio <= 3/4) {
  .container {
    max-width: none;
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
  }

  .titulo {
    font-size: 40px;
  }

  .descricao {
    font-size: 18px;
  }

  .email-button {
    font-size: 18px;
    letter-spacing: 0.02em;
  }
}
</style>
